import { render, staticRenderFns } from "./YbyScore.vue?vue&type=template&id=21e5f51b&"
import script from "./YbyScore.vue?vue&type=script&lang=ts&"
export * from "./YbyScore.vue?vue&type=script&lang=ts&"
import style0 from "./YbyScore.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports